module.exports = __webpack_public_path__ + "static/media/passo3.c209e53d.jpg";